import { Box, Skeleton } from '@mui/material';
import MultiSegmentProgressBar from '@root/components/v2/content/MultiProgressBar';
import { Bot } from 'lucide-react';
import './style.scss';

// List-row building blocks of the Non-Human Identity "Risky Identities" card, shared with the Identity
// overview cards so every identity list reads the same.

// `plainIcon` drops the tinted tile behind the icon.
export function AccountIdentity({ name, subtitle, icon, plainIcon = false }) {
  return (
    <div className="RiskyIdentityList__identity">
      <span
        className={`RiskyIdentityList__identity-icon ${plainIcon ? 'RiskyIdentityList__identity-icon--plain' : ''}`}>
        {icon ?? <Bot size={17} />}
      </span>
      <span className="RiskyIdentityList__identity-text">
        <strong>{name}</strong>
        <small>{subtitle}</small>
      </span>
    </div>
  );
}

export function RiskSeverityProgress({ severity = {}, totalCount = 0 }) {
  const { CRITICAL = 0, LOW = 0, MEDIUM = 0, HIGH = 0, WARNING = 0 } = severity;
  const segments = [
    { color: '#DC6B8A', value: CRITICAL, tooltipText: `Critical: ${CRITICAL}` },
    { color: '#FFD19F', value: HIGH, tooltipText: `High: ${HIGH}` },
    { color: '#FFC444', value: MEDIUM, tooltipText: `Medium: ${MEDIUM}` },
    { color: '#8AECC5', value: LOW, tooltipText: `Low: ${LOW}` },
    { color: '#ED7760', value: WARNING, tooltipText: `Warning: ${WARNING}` },
  ];

  return (
    <div className="RiskyIdentityList__risk-progress">
      <MultiSegmentProgressBar data={segments} total={totalCount || 1} />
      <span className="RiskyIdentityList__risk-total">{totalCount}</span>
    </div>
  );
}

export function RiskyIdentityRow({ name, subtitle, icon, plainIcon, severity, totalCount, onClick, testId }) {
  return (
    <div
      className={`RiskyIdentityList__row ${onClick ? 'RiskyIdentityList__row--clickable' : ''}`}
      {...(onClick && { onClick, 'data-clickable': 'true', 'data-testid': testId })}>
      <AccountIdentity name={name} subtitle={subtitle} icon={icon} plainIcon={plainIcon} />
      <RiskSeverityProgress severity={severity} totalCount={totalCount} />
    </div>
  );
}

export function RiskyIdentityListSkeleton({ rows = 5, plainIcon = false, sx }) {
  return Array.from({ length: rows }, (_, i) => (
    <Box
      key={i}
      display="flex"
      alignItems="center"
      gap="10px"
      py="10px"
      borderTop={i > 0 ? '1px solid #edf0f4' : 'none'}>
      {plainIcon ? (
        <Skeleton variant="rounded" width={17} height={17} sx={{ flexShrink: 0, borderRadius: '4px', ...sx }} />
      ) : (
        <Skeleton variant="rounded" width={31} height={31} sx={{ flexShrink: 0, borderRadius: '7px', ...sx }} />
      )}
      <Box flex={1}>
        <Skeleton width="70%" height={14} sx={sx} />
        <Skeleton width="40%" height={12} sx={{ mt: 0.5, ...sx }} />
      </Box>
    </Box>
  ));
}
